<component :is="resolvedTag" v-bind="forwardedAttrs" :class="computedClasses" :data-typography-variant="variant"><slot></slot></component>